import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';

import { PatientDocumentsModel } from 'src/app/models/PatientDocumentsModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientDocumentsService } from 'src/app/services/PatientDocumentsService';
import { PatientDocumentsEditComponent } from '../patient-documents-edit/patient-documents-edit.component';
import { URLsConfig } from 'src/app/URLsConfig';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-patient-documents',
  templateUrl: './patient-documents.component.html',
  styleUrls: ['./patient-documents.component.css']
})
export class PatientDocumentsComponent implements OnInit {
id = 0 ;
patientcode = '' ;
patientname = '';
doccode = '' ;
docname = '' ;
docdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
doctype = '' ;
pathimage = '' ;
fileBytes ='';
docnotes = '';
userid = '' ;
modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
compcode = '1' ;

Wk_DocCode = 0;
  myimage :any;
  PatientDocumentsList: PatientDocumentsModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public storage: LocalStorageService,
              public dataBankService : DataBankService,
              public patientsSelectedData :DatabankModel,
              public patientdocumentsservice : PatientDocumentsService,
              public patientdocuments : PatientDocumentsModel,
              private dialogref: MatDialog,
              public urlsconfig: URLsConfig,
              private sanitizer: DomSanitizer
             ) { }

  ngOnInit(): void {
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.RertivePatient();
  }
  RertivePatient(){

    this.dataBankService.getPatient(this.patientcode,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.patientname = data.patientFName;

    })
    this.RetrivePatientDocuments();
  }
  OpenEmployeeDialog(){
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.patientcode = result.patientCode;
        this.RertivePatient();

        dialogSubmitSubscription.unsubscribe();

      });

  }
  RetrivePatientDocuments(){
    this.PatientDocumentsList=[];
    this.Wk_DocCode = -1;
    this.patientdocumentsservice.GetPatientDocuments(this.patientcode, this.storage.retrieve('stgcompCode'),'Pathology').subscribe(
      (data: PatientDocumentsModel[]) => {
        for (let i = 0; i < data.length; i++) {
        this.PatientDocumentsList[i] = data[i];
        this.PatientDocumentsList[i].id = data[i].id;
        this.PatientDocumentsList[i].pathimage_1 = data[i].pathimage;
        this.PatientDocumentsList[i].docdate = formatDate(data[i].docdate, 'yyyy-MM-dd', 'en');
        if(this.PatientDocumentsList[i].doctype == 'PDF'){this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/pdf.jpg' }
        if(this.PatientDocumentsList[i].doctype == 'Excel'){this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/excel.jpg' }
        if(this.PatientDocumentsList[i].doctype == 'Word'){this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Word.jpg' }
        if(this.PatientDocumentsList[i].doctype == 'Image'){ //this.PatientDocumentsList[i].pathimage_1 = '../assets/Documents/Image.jpg'
          this.PatientDocumentsList[i].pathimage_1 = this.urlsconfig.StaticFilepath + data[i].pathimage;
          console.log("Image COC:", this.PatientDocumentsList[i].pathimage_1)
        }

        this.Wk_DocCode = i;
        ////================================================================================
        }

      }

    );
  }
  openDialogTransEditN(sup :PatientDocumentsModel){
    const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
      {
        data: {
          dataKey: this.patientdocuments,
          patientcode : this.patientcode,
          docid :sup.id,
          doccode :sup.doccode,
          docname :sup.docname,
          docdate :sup.docdate,
          doctype :sup.doctype,
          docnotes :sup.docnotes,
          pathimage: sup.pathimage,
          pathimage_1: sup.pathimage_1,
          fileBytes : 'Ex',

        },
        width: '60vw',


      });
    dialogRef.afterClosed().subscribe(result => {
      this.RetrivePatientDocuments();
    });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });

  }
  openDialogViwer(sup :PatientDocumentsModel){

    return (this.urlsconfig.StaticFilepath + sup.pathimage);
    //return  this.urlsconfig.StaticFilepath + sup.pathimage;

  }

  DialogNewRecord(){
    const dialogRef = this.dialogref.open(PatientDocumentsEditComponent,
      {
        data: {
          dataKey: this.patientdocuments,
          patientcode : this.patientcode,
          docid :0,
          doccode :this.Wk_DocCode +2,
          docdate :formatDate(new Date(), 'yyyy-MM-dd', 'en'),
          doctype : 'PDF',
          docnotes :'',
          pathimage: '',
          pathimage_1: '../assets/Documents/pdf.jpg',
          fileBytes : 'New',

        },
        width: '60vw',


      });
    dialogRef.afterClosed().subscribe(result => {
      this.RetrivePatientDocuments();
    });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });

  }
  Cloase_Dialog(){
   this.storage.store('stgPatientCode',this.patientcode);

  }
  mesgDelete(){}

}
